/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Fri Dec 20 2024
 **/
import { create } from "zustand";

type MessageStatus = "pending" | "success" | "failed";

export interface Message {
	message: string;
	replyToMessageId?: string;
	emergency: boolean;
	roomType: "DM" | "CHANNEL" | "OPEN_WORLD" | "AUDIO_ZONE" | "MEETING" | "MY_ROOM";
	roomId: string;
	mentionType?: "ALL" | "ID";
	mentionIds?: string[];
	spaceId?: string;
	sender: {
		id?: string;
		name?: string;
		profileImagePath?: string;
		colorProfile?: string;
	};
	files?: { data: string; fileBoxId: string }[];
	clientMessageId: string;
	timestamp: number;
	messageId?: string;
	status?: MessageStatus;
}

interface MessageStore {
	messages: Record<string, Message>;
	addMessage: (message: Message) => void;
	updateMessageStatus: (id: string, status: MessageStatus) => void;
	removeMessage: (id: string) => void;
}

const useMessageStore = create<MessageStore>((set) => ({
	messages: {},
	addMessage: (message: Message) =>
		set((state) => ({
			messages: {
				...state.messages,
				[message.clientMessageId]: { ...message, status: "pending" }
			}
		})),
	updateMessageStatus: (clientMessageId, status) =>
		set((state) => ({
			messages: {
				...state.messages,
				[clientMessageId]: { ...state.messages[clientMessageId], status }
			}
		})),
	removeMessage: (clientMessageId) =>
		set((state) => {
			const { [clientMessageId]: _, ...rest } = state.messages;
			return { messages: rest };
		})
}));

export default useMessageStore;
